import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as satrActionTypes from '../satrActionTypes';

/**
 * Search SATR destination geolocation
 */
const searchSATRDestinationGeolocation = function* searchSATRDestinationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        satrActionTypes.SEARCH_SATR_DESTINATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        satrActionTypes.SEARCH_SATR_DESTINATION_GEOLOCATION_REQUEST_SUCCEEDED,
        satrActionTypes.SEARCH_SATR_DESTINATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: satrActionTypes.SET_SATR_DESTINATION_CANDIDATES,
            payload: {
                locationKey: 'destination',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSATRDestinationGeolocation;
